import { ReferentialDto } from 'api/referential';
import { DropdownItem } from 'components/forms/Dropdown';
import { ReactNode } from 'react';

/**
 * Convertit un ReferentialDto en DropdownItem
 * @param referential - L'objet ReferentialDto à convertir
 * @param icon - Icône optionnelle à ajouter au DropdownItem
 * @returns DropdownItem correspondant
 */
export const mapReferentialToDropdownItem = (
  referential: ReferentialDto,
  icon?: ReactNode
): DropdownItem<string> => ({
  key: referential.code,
  label: referential.label,
  ...(icon && { icon })
});

/**
 * Convertit un tableau de ReferentialDto en tableau de DropdownItem
 * @param referentials - Le tableau de ReferentialDto à convertir
 * @param getIcon - Fonction optionnelle pour obtenir l'icône pour chaque élément
 * @returns Tableau de DropdownItem correspondant
 */
export const mapReferentialsToDropdownItems = (
  referentials: ReferentialDto[],
  getIcon?: (referential: ReferentialDto) => ReactNode
): DropdownItem<string>[] => 
  referentials.map(ref => mapReferentialToDropdownItem(ref, getIcon?.(ref)));
